// import moment from "moment";
// import React from "react";
// import { literToKiloliter } from "../utils/utils";
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     BarElement,
//     BarController,
//     TimeScale,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js'
// import { Bar } from 'react-chartjs-2'

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     BarController,
//     TimeScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ChartDataLabels
// )

// const bgColor = [
//     'rgba(59, 130, 246, 0.7)',
//    ' rgba(163, 199, 244, 0.7)',
// ]

// const borderColor = [
//     'rgba(147, 197, 253, 1)', 
//     'rgba(37, 99, 235, 1)',
// ]

// function HourlyBarChart({ dates, water_data, id, hourly = false }) {
//     // let dates_array = dates && !hourly ? dates.map(date => moment(date).format("DD MMM")) : dates;
//     let dates_array = dates && !hourly 
//   ? dates.map(date => moment(date).format("DD MMM")) 
//   : dates.map(date => date.replace(/ (am|pm)$/i, ""));


//     const datas = {
//         labels: dates_array,
//         datasets: [
//             {
//                 data: water_data,
//                 backgroundColor: new Array(50).fill(bgColor).flat(),
//                 borderColor: new Array(50).fill(borderColor).flat(),
//                 borderWidth: 1,
//             },
//         ],
//     };

//     const options = {
//         maintainAspectRatio: false,
//         responsive: true,
//         tooltips: {
//             callbacks: {
//                 label: (item) => literToKiloliter(item.value),
//             },
//         },
//         layout: {
//             padding: {
//                 left: 0,
//                 right: 0,
//                 top: 30,
//                 bottom: 0,
//             },
//         },
//         legend: {
//             display: false,
//         },
//         scales: {
//             // xAxes: [
//             //     {
//             //         type: "time",
//             //         time: {
//             //             tooltipFormat: "ll",
//             //             unit: "day",
//             //             displayFormats: {
//             //                 day: "dddd",
//             //             },
//             //             parser: "yyyy-mm-dd hh:mm:ss"
//             //         },
//             //     },
//             // ],
//             yAxes: [
//                 {
//                     scaleLabel: {
//                         display: true,
//                         labelString: `Litre`
//                     },
//                     ticks: {
//                         beginAtZero: true,
//                         // max: 100
//                     },
//                 },
//             ],
//         },
//     };


//     return <div style={{
//         width: "100%",
//         height: "300px"
//     }}>
//         <Bar
//             id={id}
//             data={datas}
//             options={{
//                 indexAxis: "x",
//                 maintainAspectRatio: false,
//                 responsive: true,
//                 plugins: {
//                     legend: {
//                         display: false,
//                     },
//                     // tooltip: {
//                     //     callbacks: {
//                     //         label: (item) => {
//                     //             return literToKiloliter(item.raw);
//                     //         }
//                     //     }
//                     // },
//                     tooltip: {
//                         enabled: false,
//                     },
//                     datalabels: {
//                         display: true,
//                         anchor: 'end',
//                         align: 'top',
//                         formatter:
//                             function (value, context) {
//                                 return literToKiloliter(value);
//                             },
//                         font: {
//                             weight: 'bold'
//                         }
//                     }
//                 },
//                 layout: {
//                     padding: {
//                         left: 0,
//                         right: 0,
//                         top: 30,
//                         bottom: 0,
//                     },
//                 },
//                 scales: {
//                     y: {
//                         ticks: {
//                             font: {
//                                 weight: 'bold'
//                             },
//                         },
//                         beginAtZero: true,
//                     },
//                 },
//             }} />
//     </div>
// }

// export default HourlyBarChart;




// import React from "react";
// import { literToKiloliter } from "../utils/utils";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   BarElement,
//   BarController,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   BarController,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// // Custom AM/PM Plugin for Bars
// const ampmPlugin = {
//   id: "ampmPlugin",
//   afterDraw: (chart) => {
//     const ctx = chart.ctx;
//     const xScale = chart.scales.x;
//     const chartArea = chart.chartArea;

//     if (!xScale || !chartArea) return;

//     const yPos = chartArea.bottom + 20; // position below x-axis
//     ctx.save();
//     ctx.lineWidth = 4;

//     let amStart = null;
//     let pmStart = null;
//     const labels = chart.data.labels;

//     // Determine start of AM and PM sections
//     labels.forEach((label, index) => {
//       const rawLabel = label.toLowerCase();
//       const x = xScale.getPixelForTick(index);
//       if (rawLabel.includes("am") && amStart === null) amStart = x;
//       if (rawLabel.includes("pm") && pmStart === null) pmStart = x;
//     });

//     // If we have AM and PM positions
//     if (amStart !== null && pmStart !== null) {
//       const leftPixel = xScale.left;
//       const rightPixel = xScale.right;

//       // Draw AM line
//       ctx.strokeStyle = "#ff4444";
//       ctx.beginPath();
//       ctx.moveTo(leftPixel, yPos);
//       ctx.lineTo(pmStart, yPos);
//       ctx.stroke();

//       // Draw PM line
//       ctx.strokeStyle = "#4444ff";
//       ctx.beginPath();
//       ctx.moveTo(pmStart, yPos);
//       ctx.lineTo(rightPixel, yPos);
//       ctx.stroke();

//       // Draw AM/PM Text
//       ctx.font = "bold 14px Arial";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "top";

//       ctx.fillStyle = "#ff4444";
//       ctx.fillText("AM", (leftPixel + pmStart) / 2, yPos + 4);

//       ctx.fillStyle = "#4444ff";
//       ctx.fillText("PM", (pmStart + rightPixel) / 2, yPos + 4);
//     }

//     ctx.restore();
//   },
// };

// const bgColor = ["rgba(59, 130, 246, 0.7)", "rgba(163, 199, 244, 0.7)"];
// const borderColor = ["rgba(147, 197, 253, 1)", "rgba(37, 99, 235, 1)"];

// function HourlyBarChart({ dates, water_data, id }) {
//   // remove am/pm from labels
//   const labels = dates.map((date) => date.replace(/ (am|pm)$/i, ""));

//   const data = {
//     labels,
//     datasets: [
//       {
//         data: water_data,
//         backgroundColor: new Array(labels.length).fill(bgColor).flat(),
//         borderColor: new Array(labels.length).fill(borderColor).flat(),
//         borderWidth: 1,
//       },
//     ],
//   };

//   return (
//     <div style={{ width: "100%", height: "300px" }}>
//       <Bar
//         id={id}
//         data={data}
//         plugins={[ampmPlugin, ChartDataLabels]}
//         options={{
//           indexAxis: "x",
//           maintainAspectRatio: false,
//           responsive: true,
//           plugins: {
//             legend: { display: false },
//             tooltip: { enabled: false },
//             datalabels: {
//               display: true,
//               anchor: "end",
//               align: "top",
//               formatter: (value) => literToKiloliter(value),
//               font: { weight: "bold" },
//             },
//           },
//           layout: { padding: { left: 0, right: 0, top: 30, bottom: 40 } },
//           scales: {
//             y: { beginAtZero: true, ticks: { font: { weight: "bold" } } },
//           },
//         }}
//       />
//     </div>
//   );
// }

// export default HourlyBarChart;




import React from "react";
import { literToKiloliter } from "../utils/utils";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    BarController,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarController,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

// const bgColor = ["rgba(99, 155, 245, 0.7)", "rgba(163, 199, 244, 0.7)"];
// const borderColor = ["rgba(147, 197, 253, 1)", "rgba(37, 99, 235, 1)"];

const bgColor = [
  "rgba(16, 112, 102, 0.7)",
  "rgba(76, 175, 143, 0.7)"
];

const borderColor = [
  "rgba(11, 90, 82, 1)",
  "rgba(16, 112, 102, 1)"
];

function HourlyBarChart({ dates, water_data, id }) {
    console.log("HourlyBarChart rendered with dates:", dates);

const labels = dates.map((date) => {
  // Extract start and end hour from your range (e.g., "13 - 14")
  const [start, end] = date.split("-").map((d) => d.trim());

  const start12 = moment(start, ["HH", "HH:mm", "HH:mm:ss"]).format("h");
  const end12 = moment(end, ["HH", "HH:mm", "HH:mm:ss"]).format("h");

  return `${start12} - ${end12}`;
});

    const data = {
        labels,
        datasets: [
            {
                data: water_data,
                backgroundColor: new Array(labels.length).fill(bgColor).flat(),
                borderColor: new Array(labels.length).fill(borderColor).flat(),
                borderWidth: 1,
            },
        ],
    };

    const ampmPluginInstance = {
        id: "ampmPluginBar",
        afterDraw: (chart) => {
            console.log("=== Bar Chart AM/PM Plugin Called ===");
            console.log("Original dates:", dates);

            const ctx = chart.ctx;
            const xScale = chart.scales.x;
            const chartArea = chart.chartArea;

            if (!xScale || !chartArea) {
                console.log("No xScale or chartArea");
                return;
            }

            console.log("Chart area:", chartArea);

            const yPos = chartArea.bottom + 45;

            let pmStartIndex = -1;
            dates.forEach((date, index) => {
                const dateStr = String(date).toLowerCase();
                if (dateStr.includes("pm") && pmStartIndex === -1) {
                    pmStartIndex = index;
                    console.log("Found PM at index:", index);
                }
            });

            if (pmStartIndex === -1) {
                console.log("No PM found in dates");
                return;
            }

            ctx.save();

            const leftPixel = chartArea.left;
            const rightPixel = chartArea.right;

            const totalLabels = dates.length;
            const barWidth = (rightPixel - leftPixel) / totalLabels;
            const pmStartPixel = leftPixel + (pmStartIndex * barWidth);

            console.log("Drawing lines - Left:", leftPixel, "PM Start:", pmStartPixel, "Right:", rightPixel);

            // ctx.strokeStyle = "#ff0000";
            ctx.strokeStyle = "#107066";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(leftPixel, yPos);
            ctx.lineTo(pmStartPixel, yPos);
            ctx.stroke();
            ctx.strokeStyle = "#0000ff";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(pmStartPixel, yPos);
            ctx.lineTo(rightPixel, yPos);
            ctx.stroke();

            ctx.font = "bold 12px Arial";
            ctx.textAlign = "center";
            ctx.textBaseline = "top";

            // ctx.fillStyle = "#ff0000";
            ctx.fillStyle = "#0b5a52";
            const amCenter = (leftPixel + pmStartPixel) / 2;
            ctx.fillText("AM", amCenter, yPos + 8);

            ctx.fillStyle = "#0000ff";
            const pmCenter = (pmStartPixel + rightPixel) / 2;
            ctx.fillText("PM", pmCenter, yPos + 8);

            console.log("Drew AM at", amCenter, "and PM at", pmCenter);

            ctx.restore();
        },
    };



    return (
        <div style={{ width: "100%", height: "300px" }}>
            <Bar
                id={id}
                data={data}
                plugins={[ampmPluginInstance, ChartDataLabels]}
                // options={{
                //   indexAxis: "x",
                //   maintainAspectRatio: false,
                //   responsive: true,
                //   plugins: {
                //     legend: { display: false },
                //     tooltip: { enabled: false },
                //     datalabels: {
                //       display: true,
                //       anchor: "end",
                //       align: "top",
                //       formatter: (value) => literToKiloliter(value),
                //       font: { weight: "bold" },
                //     },
                //     ampmPluginBar: {},
                //   },
                //   layout: { padding: { left: 0, right: 0, top: 30, bottom: 70 } },
                //   scales: {
                //     y: { beginAtZero: true, ticks: { font: { weight: "bold" } } },
                //   },
                // }}

                options={{
                    indexAxis: "x",
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false },
                        datalabels: {
                            display: true,
                            anchor: "end",
                            align: "top",
                            formatter: (value) => literToKiloliter(value),
                            font: { weight: "bold" },
                        },
                        ampmPluginBar: {},
                    },
                    layout: { padding: { left: 0, right: 0, top: 30, bottom: 40 } },
                    scales: {
                        // y: {
                        //     beginAtZero: true,
                        //     ticks: {
                        //         font: { weight: "bold" },
                        //           lineHeight: 0.2
                        //     },
                        //     title: {
                        //         display: true,
                        //         text: "Liters",
                        //         font: {
                        //             size: 12,
                        //             weight: "bold"
                        //         },
                        //          padding: { top: 0, bottom: 0 }
                        //     }
                        // }
                        y: {
  beginAtZero: true,
  ticks: {
    color: "#107066",
    font: { weight: "bold" }
  },
  title: {
    display: true,
    text: "Liters",
    color: "#107066",
    font: {
      size: 12,
      weight: "bold"
    }
  }
}
                    }
                }}

            />
        </div>
    );
}

export default HourlyBarChart;